<template lang="pug">
  // TABLE that displays CRM
  div
    p(v-if='loading')
    app-table(:data='tableItems', :label='tableFields', sortBy='timestamp', :sortDesc='true', v-else)
</template>

<script>
import { db } from '@/firebase'
// import numeral from 'numeral'

const customRef = db.ref('custom')

export default {
  name: 'crm-table-appointment',
  data() {
    return {
      cls: {},
      loading: true,
      tableItems: [
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center',
        },
        upperCase: {
          label: 'Car Plate',
        },
        intent: {
          label: 'Workshop Name',
        },
        timestamp: {
          label: 'Timestamp',
          sortable: true,
        },
        statusString: {
          label: '<i></i>',
          class: 'text-right',
          thStyle: {
            minWidth: '26em',
          },
        },
      },
    }
  },
  mounted: function() {
    var customs
    customRef.child('motorAccident').on('value', (snapshot) => {
      customs = []
      Object.entries(snapshot.val()).forEach(
        function([key, val]) {
          customs.unshift({
            avatar: { url: val.profilePic, tooltip: key },
            name: val.name,
            upperCase: val.carplate,
            timestamp: parseInt(val.timestamp),
            intent: val.workshopName,
            // statusString: { formUrl: 'null', mapUrl: val.location.googleMapsLink, carUrl: 'null', imageUrl: val.imageUrl }
            statusString: { formUrl: 'null', mapUrl: val.location.googleMapsLink, carUrl: 'null', imageUrl: val.imageUrl, btn1: 'Followed Up', btn2: 'Email', btn3: 'Make Remark', email: 'null', id: key, crm: 'motorAccident', resolved: val.resolved, userAccessLevel: self.userAccessLevel, remark: val.remark },
            _rowVariant: val.resolved && 'success',
          })
        })
      // console.log(customs)
      this.tableItems = customs
      this.loading = false
    })
  },
}
</script>



// WEBPACK FOOTER //
// src/fragments/crmTableAppointment.vue?1892c6f2